<template>
  <div class="customer-editor">
    <header-tip>
      信息完整率： {{computeDataFullRate}}%
    </header-tip>
      <el-form :model="form" ref="form">

        <el-row :gutter="0">
          <el-col :span="11">

            <el-form-item label="客户名称" :label-width="width" prop="name">
              <el-input v-model="form.name" autocomplete="off" size="mini" readonly></el-input>
              <el-input v-if="diffData(form.name, old_form.name)" v-model="old_form.name" autocomplete="off" size="mini" readonly class="diff-form"></el-input>
            </el-form-item>
            <el-form-item label="客户分类" :label-width="width" :required="true">
              <el-select v-model="form.category" placeholder="请选择" size="mini" readonly>
                <el-option label="特别重要客户★★★★★" value="1"></el-option>
                <el-option label="重要客户★★★★" value="2"></el-option>
                <el-option label="普通客户★★★" value="3"></el-option>
                <el-option label="问题客户★★" value="4"></el-option>
                <el-option label="劣质客户★" value="5"></el-option>
              </el-select>
              <el-select v-if="diffData(form.category, old_form.category)" v-model="old_form.category" placeholder="请选择" size="mini" readonly class="diff-form">
                <el-option label="特别重要客户★★★★★" value="1"></el-option>
                <el-option label="重要客户★★★★" value="2"></el-option>
                <el-option label="普通客户★★★" value="3"></el-option>
                <el-option label="问题客户★★" value="4"></el-option>
                <el-option label="劣质客户★" value="5"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属组织" :label-width="width" :required="true">
<!--              <el-input v-model="form.organization" autocomplete="off"></el-input>-->
              <el-select v-model="form.organization_project_id" clearable filterable placeholder="所属组织" size="mini" readonly>
                <el-option
                  v-for="item in project_list"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-select v-if="diffData(form.organization_project_id, old_form.organization_project_id)" v-model="old_form.organization_project_id" clearable filterable placeholder="所属组织" size="mini" readonly class="diff-form">
                <el-option
                  v-for="item in project_list"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="性别" :label-width="width" :required="true">
              <el-radio v-model="form.sex" label="1">男</el-radio>
              <el-radio v-model="form.sex" label="2">女</el-radio>
            </el-form-item>
            <el-form-item label="民族" :label-width="width" :required="true">
              <el-select v-model="form.nation" filterable placeholder="请选择" size="mini" readonly>
                <el-option v-for="item in nativeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              <el-select v-if="diffData(form.nation, old_form.nation)" v-model="old_form.nation" placeholder="请选择" size="mini" readonly class="diff-form">
                <el-option v-for="item in nativeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="国籍" :label-width="width" :required="true">
              <el-select v-model="form.country" filterable placeholder="请选择" size="mini" readonly>
                <el-option v-for="item in countryList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              <el-select v-if="diffData(form.country, old_form.country)" v-model="old_form.country" placeholder="请选择" size="mini" readonly class="diff-form">
                <el-option v-for="item in countryList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="证件类型" :label-width="width" :required="true">
              <el-select v-model="form.credentials_type" filterable placeholder="请选择" size="mini" readonly>
                <el-option v-for="item in credentialsList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              <el-select v-if="diffData(form.credentials_type, old_form.credentials_type)" v-model="old_form.credentials_type" placeholder="请选择" size="mini" readonly class="diff-form">
                <el-option v-for="item in credentialsList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="证件号码" :label-width="width" :required="true">
              <el-input v-model="form.credentials_code" autocomplete="off" size="mini" readonly></el-input>
              <el-input v-if="diffData(form.credentials_code, old_form.credentials_code)" v-model="old_form.credentials_code" autocomplete="off" size="mini" readonly class="diff-form"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" :label-width="width" :required="true">
              <el-input v-model="form.contact_number" autocomplete="off" size="mini" readonly></el-input>
              <el-input v-if="diffData(form.contact_number, old_form.contact_number)" v-model="old_form.contact_number" autocomplete="off" size="mini" readonly class="diff-form"></el-input>
            </el-form-item>
            <el-form-item label="出生日期" :label-width="width" :required="true">
              <el-date-picker v-model="form.birthday" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" size="mini" readonly></el-date-picker>
              <el-date-picker v-if="diffData(form.birthday, old_form.birthday)" v-model="old_form.birthday" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" size="mini" readonly class="diff-form"></el-date-picker>
            </el-form-item>
            <el-form-item label="籍贯" :label-width="width" :required="true">
              <el-input v-model="form.native_place" autocomplete="off" size="mini" readonly></el-input>
              <el-input v-if="diffData(form.native_place, old_form.native_place)" v-model="old_form.native_place" autocomplete="off" size="mini" readonly class="diff-form"></el-input>
            </el-form-item>
            <el-form-item label="户口所在地" :label-width="width" :required="true">
              <el-input type="textarea" v-model="form.registered_residence" size="mini" readonly></el-input>
              <el-input type="textarea" v-if="diffData(form.registered_residence, old_form.registered_residence)" v-model="old_form.registered_residence" size="mini" readonly class="diff-form"></el-input>
            </el-form-item>


          </el-col>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="11">

            <el-form-item label="省/市" :label-width="width">

              <el-col :span="12">
                <el-select v-model="form.province" @change="changeProvince" filterable placeholder="请选择" size="mini" readonly>
                  <el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
                <el-select v-if="diffData(form.province, old_form.province)" v-model="old_form.province" placeholder="请选择" size="mini" readonly class="diff-form">
                  <el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-col>
              <el-col class="line" :span="1">&nbsp;</el-col>
              <el-col :span="11">
                <el-select v-model="form.city" filterable placeholder="请选择" size="mini" readonly>
                  <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
                <el-select v-if="diffData(form.city, old_form.city)" v-model="old_form.city" placeholder="请选择" size="mini" readonly class="diff-form">
                  <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-col>

            </el-form-item>

            <el-form-item label="家庭地址" :label-width="width" :required="true">
              <el-input v-model="form.home_address" autocomplete="off" size="mini" readonly></el-input>
              <el-input v-if="diffData(form.home_address, old_form.home_address)" v-model="old_form.home_address" autocomplete="off" size="mini" readonly class="diff-form"></el-input>
            </el-form-item>
            <el-form-item label="邮寄地址" :label-width="width" :required="true">
              <el-input v-model="form.post_address" autocomplete="off" size="mini" readonly></el-input>
              <el-input v-if="diffData(form.post_address, old_form.post_address)" v-model="old_form.post_address" autocomplete="off" size="mini" readonly class="diff-form"></el-input>
            </el-form-item>

            <el-form-item label="文化程序" :label-width="width">
              <el-select v-model="form.cultural_procedures" filterable placeholder="请选择" size="mini" readonly>
                <el-option v-for="item in culturalList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              <el-select v-if="diffData(form.cultural_procedures, old_form.cultural_procedures)" v-model="old_form.cultural_procedures" placeholder="请选择" size="mini" readonly class="diff-form">
                <el-option v-for="item in culturalList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="婚姻状况" :label-width="width">
              <el-radio v-model="form.marital_status" label="1">未婚</el-radio>
              <el-radio v-model="form.marital_status" label="2">已婚</el-radio>
              <el-radio v-model="form.marital_status" label="0">其它</el-radio>
            </el-form-item>

            <el-form-item label="常住类型" :label-width="width">
              <el-radio v-model="form.live_type" label="1">户籍</el-radio>
              <el-radio v-model="form.live_type" label="2">非户籍</el-radio>
            </el-form-item>

            <el-form-item label="客户类型" :label-width="width" prop="type">
              <el-checkbox-group v-model="form.type" size="mini" readonly>
                  <el-checkbox label="1">业主</el-checkbox>
                  <el-checkbox label="2">租户</el-checkbox>
                  <el-checkbox label="3">住户</el-checkbox>
                  <el-checkbox label="4">共有人</el-checkbox>
                  <el-checkbox label="5">开发商</el-checkbox>
                  <el-checkbox label="9">其它</el-checkbox>
                </el-checkbox-group>
              <el-checkbox-group v-if="diffData(form.type, old_form.type)" v-model="old_form.type" size="mini" readonly class="diff-form">
                  <el-checkbox label="1">业主</el-checkbox>
                  <el-checkbox label="2">租户</el-checkbox>
                  <el-checkbox label="3">住户</el-checkbox>
                  <el-checkbox label="4">共有人</el-checkbox>
                  <el-checkbox label="5">开发商</el-checkbox>
                  <el-checkbox label="9">其它</el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="紧急联系人" :label-width="width" :required="true">
              <el-input v-model="form.emergency_contact" autocomplete="off" size="mini" readonly></el-input>
              <el-input v-if="diffData(form.emergency_contact, old_form.emergency_contact)" v-model="old_form.emergency_contact" autocomplete="off" size="mini" readonly class="diff-form"></el-input>
            </el-form-item>

            <el-form-item label="紧急联系人电话" :label-width="width" :required="true">
              <el-input v-model="form.emergency_number" autocomplete="off" size="mini" readonly></el-input>
              <el-input v-if="diffData(form.emergency_number, old_form.emergency_number)" v-model="old_form.emergency_number" autocomplete="off" size="mini" readonly class="diff-form"></el-input>
            </el-form-item>

            <el-form-item label="物业费日期" :label-width="width">
<!--               <el-date-picker v-model="form.fee_date" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>-->

              <el-row>
                <el-col :span="10">
                  <el-date-picker
                    v-model="form.fee_start_date"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    clearable
                    placeholder="选择开始时间" size="mini" readonly>
                  </el-date-picker>
                  <el-date-picker
                    v-if="diffData(form.fee_start_date, old_form.fee_start_date)"
                    v-model="old_form.fee_start_date"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    clearable
                    placeholder="选择开始时间" size="mini" readonly class="diff-form">
                  </el-date-picker>
                </el-col>
                <el-col :span="4">至</el-col>
                <el-col :span="10">
                  <el-date-picker
                    v-model="form.fee_end_date"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    clearable
                    placeholder="选择结束时间" size="mini" readonly>
                  </el-date-picker>
                  <el-date-picker
                    v-if="diffData(form.fee_end_date, old_form.fee_end_date)"
                    v-model="old_form.fee_end_date"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    clearable
                    placeholder="选择结束时间" size="mini" readonly class="diff-form">
                  </el-date-picker>
                </el-col>
              </el-row>
            </el-form-item>

          </el-col>
        </el-row>


      </el-form>

  </div>
</template>

<script>

  import Common from '../../common.js'
  import HeaderTip from "../../../Common/header-tip";

  export default {
    name: "personal-basic-preview",
    components: {HeaderTip},
    props: {
      width: {
        type: String,
        default() {
          return '110px'
        }
      },
      form_data: {
        type: Object,
        default() {
          return {}
        }
      },
      form_old_data: {
        type: Object,
        default() {
          return {}
        }
      },
    },
    data(){
      return{
        loading: false,
        form: this.getFormData({}),
        old_form: this.getFormData({}),
        rules: {
          name: [
            { required: true, message: '请输入活动名称', trigger: 'blur' },
            { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
          ],
          type: [
            { type: 'array', required: true, message: '请至少选择一个客户类型', trigger: 'change' }
          ],
          organization_project_id: [
            { type: 'string',required: true, message: '请选择所属组织', trigger: 'change' },
          ],
        },
        nativeList: ["汉","朝鲜","满","侗","瑶","白","土家","哈尼","哈萨克","傣","黎","蒙古","僳僳","佤","畲","高山","拉祜","水","东乡","纳西","景颇","柯尔克孜","回","土","达斡尔","仫佬","羌","布朗","撒拉","毛南","仡佬","锡伯","阿昌","藏","普米","塔吉克","怒","乌孜别克","俄罗斯","鄂温克","德昂","保安","裕固","京","维吾尔","塔塔尔","独龙","鄂伦春","赫哲","门巴","珞巴","基诺","苗","彝","壮","布依"].map(item => {
          return {value: item, label: item}
        }),
        countryList: [{value: '中华人民共和国', label: '中华人民共和国'}],
        credentialsList: [{"value":"1","label":"居民身份证"},{"value":"11","label":"离休干部荣誉证"},{"value":"12","label":"护照"},{"value":"9","label":"文职干部证"},{"value":"6","label":"士兵证"},{"value":"8","label":"军官退休证"},{"value":"2","label":"临时身份证"},{"value":"15","label":"外国人永久居留证"},{"value":"16","label":"其他"},{"value":"13","label":"港澳台同胞来往通行证"},{"value":"10","label":"文职干部退休证"},{"value":"3","label":"户口簿"},{"value":"4","label":"军官证"},{"value":"5","label":"警官证"},{"value":"7","label":"军事学院证"},{"value":"14","label":"边民出入境通行证"},{"value":"17","label":"居民身份证（台）"}],
        provinceList: [],
        cityList: [],
        culturalList: [{"value":"1","label":"文盲"},{"value":"2","label":"初中及以下"},{"value":"3","label":"高中或中专"},{"value":"4","label":"大专"},{"value":"5","label":"本科"},{"value":"6","label":"硕士"},{"value":"7","label":"博士"},{"value":"8","label":"其他"}],
        confirmText: '保 存',
        project_list:[],

      }
    },
    mounted() {
      this.getProjectList();
      this.showConfirmText()
      this.form = this.getFormData(this.form_data)
      this.old_form = this.getFormData(this.form_old_data)
      this.callbackRegion()
    },
    methods: {
      getFormData(data) {

        let object = {
          id: 0,
          name: '',
          category: '',
          organization: '',
          organization_project_id:"",
          nation: '',
          country: '',
          credentials_type: '',
          credentials_code: '',
          contact_number: '',
          birthday: '',
          native_place: '',
          registered_residence: '',
          province: '',
          city: '',
          home_address: '',
          post_address: '',
          cultural_procedures: '',
          marital_status: '',
          live_type: '',
          type: [],
          emergency_contact: '',
          emergency_number: '',
          fee_date: '',
          fee_start_date:'',
          fee_end_date:'',
          sex: '',
        }

        data.sex += ''
        data.category = data.category === 0 ? '' : data.category += ''
        data.marital_status += ''
        data.credentials_type = data.credentials_type === 0 ? '' : data.credentials_type += ''
        data.live_type = data.live_type === 0 ? '' : data.live_type += ''
        data.cultural_procedures = data.cultural_procedures == 0 ? '' : data.cultural_procedures += ''
        data.province = data.province === 0 ? '' : data.province
        data.city = data.city === 0 ? '' : data.city
        if(typeof data.type == 'string') data.type = data.type.split(',')
        if(!data.fee_date && data.fee_start_date) data.fee_date = [Common.timeFormat(data.fee_start_date, false), Common.timeFormat(data.fee_end_date, false)]
        if(data.fee_start_date) {
          data.fee_start_date=Common.timeFormat(data.fee_start_date, false)
        }else {
          data.fee_start_date=""
        }
        if(data.fee_end_date) {
          data.fee_end_date=Common.timeFormat(data.fee_end_date, false)
        }else {
          data.fee_end_date=""
        }
        // data.birthday = data.birthday > 0 ? Common.timeFormat(data.birthday, false) : ''

        return Object.assign(object, data)
      },

      getData() {

        let callback = res => {

          this.getRegion(0, res => {
            this.provinceList = res
            if(this.form.province) {
              this.getRegion(this.form.province, res => {
                this.cityList = res
              })
            }
          })

        }

        if(this.id > 0) {
          this.loading = true
          this.$myhttp.get('admin/Customer/getPersonalBasicInfo?customer_id='+this.id).then(backdata => {
            let res = backdata.data
            if(res.code == 200) {
              this.form = this.getFormData(res.data)
              this.old_form = this.getFormData(res.data)
              callback()
            } else {
              this.$message.error('获取客户信息出错！');
            }
            this.loading = false
          })
        } else {
          this.form = this.getFormData({})
          this.old_form=this.getFormData({})
          callback()
        }

      },

      callbackRegion(){
        const that=this;
        that.$nextTick(() => {
          that.getRegion(0, res => {
            that.provinceList = res
            if(that.form.province) {
              that.getRegion(that.form.province, res => {
                that.cityList = res
              })
            }
          });
        });
      },

      getRegion(parentId = 0, callback) {
        this.$myhttp.get('admin/Customer/getRegion?parent_id=' + parentId).then(backdata => {
          if(backdata.status == 200) {
            callback(backdata.data)
          } else {
            this.$message.error('获取省市信息出错！');
          }
          this.$Loading.finish();
        });
      },
      changeProvince(proviceId) {
        this.form.city = ''
        this.getRegion(proviceId, res => {
          this.cityList = res
        })
      },
      submitForm(formName) {
        let that = this
        this.$refs[formName].validate((valid) => {
          if (valid) {

            let data = Object.assign({}, this.form)

            if(!data.organization_project_id){
              window.alert("请选择归属组织（项目）");
              return false;
            }
            data.type = data.type.join(',')

            let old_data = Object.assign({}, this.old_form)
            old_data.type = old_data.type.join(',')

            if(JSON.stringify(data) === JSON.stringify(old_data)) {
              this.$message.warning('数据未修改，请修改后再提交！')
              return false
            }
            data.old_form = JSON.stringify(old_data);

            this.$myhttp.post('admin/Customer/savePersonalBasic', data).then(backdata => {
              let res = backdata.data
              this.$message({
                message: res.msg,
                type: res.code == 200 ? 'success' : 'error'
              })
              if(res.code == 200) {
                this.$emit('callback', res.customer_id)
              }

              this.$Loading.finish();
            });

          } else {
            return false;
          }
        });
      },
      showConfirmText() {
        this.confirmText = this.id > 0 ? '保 存' : '下一步'
      },
      getProjectList(){
        const that=this;
        ERP.getRequest({
          url:"admin/Project/getProjectList",
          data:{}
        },ret=>{
          if(ret.code){
            that.project_list=ret.data;
          }
        })
      },
      diffData(val1, val2) {
        return JSON.stringify(val1)!== JSON.stringify(val2)
      },
    },
    watch: {
      form_data: {
        handler(newVal, oldVal) {
          this.form = this.getFormData(newVal||{})
          this.callbackRegion();
        },
        deep: true
      },
      form_old_data: {
        handler(newVal, oldVal) {
          this.old_form = this.getFormData(newVal||{})
        },
        deep: true
      },
    },
    computed:{
      computeDataFullRate(){
        return computeDataFull(this.form)
      }
    }
  }

  //计算信息完整率
  const computeDataFull=(obj)=>{
    const required_array =['name','category','organization_project_id','sex','nation','country','credentials_type','credentials_code','contact_number','birthday','native_place','registered_residence','home_address','post_address','type','emergency_contact','emergency_number'];
    let complete_num=0;
    let all_num=required_array.length;
    required_array.forEach(item => {
      if (typeof obj[item]==="undefined") {
        return false;
      }
      if(typeof obj[item]==='string'&&obj[item]!==''){
        complete_num++;
      }else if(typeof obj[item]==='number'&&obj[item]!==0){
        complete_num++;
      }else if(typeof obj[item]==='object'&&obj[item]!==null&&Object.keys(obj[item]).length>0){
        complete_num++;
      }
    })
    return (complete_num/all_num*100).toFixed(2)
  }
</script>

<style lang="scss" scoped>

@import "../../common.scss";

  .line {
    text-align: center;
  }
.diff-form {
  border: 1px solid #ff3d00;
  color: #ff3d00;
}


</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/components/preview/personal-basic-preview.vue